module.exports = __webpack_public_path__ + "img/qilin-stage6-hungry.43f520c4.png";